<script>
    import {onMount} from "svelte";

    export let value = '';
    export let label;
    export let options;
    let fill = false;
    let focus = false;
    export let isDisabled = false;

    onMount(() => {
        setStatus();
    });

    function setStatus() {
        focus = false;
    }
</script>
<div class="naui-field active w-100">
    <div class="naui-field-back" class:fill={fill}>
        <label class:focus={focus}>{label}</label>
        {#if isDisabled}
            <div class="naui-input w-100" style="padding-top: .8rem">
                {options.find(o => o.value === value)?.label}
            </div>
        {:else}
            <select class="naui-input w-100"
                    bind:value={value}
                    on:focusin={()=>focus=false}
                    on:change
                    readonly={!isDisabled}>
                <option value="" hidden>{label}</option>
                {#each options as option, i}
                    {#if option.options}
                        <optgroup label={option.name}>
                            {#each option.options as sub}
                                <option value={sub.value}>{sub.label}</option>
                            {/each}
                        </optgroup>
                    {:else}
                        <option value="{option.value}">{option.label}</option>
                    {/if}
                {/each}
            </select>
        {/if}
    </div>
</div>
<style>
    select {
        font-size: .95rem;
    }

    .naui-field-back.fill {
        background: white;
    }
</style>
